import React from "react";
import { useParams } from "react-router-dom";
import { useOrderView } from "../hooks/useOrderView";
import OrderPaymentView from "./OrderPaymentView";


export default function OrderPaymentViewPage() {
    const { orderId } = useParams<{
        orderId: string;
    }>();

    const parsedOrderId = Number(orderId);

    if (!Number.isFinite(parsedOrderId) || parsedOrderId <= 0) {
        return (
            <div className="p-6 text-sm text-red-600">
                Invalid order ID.
            </div>
        );
    }

    const {
        data,
        isLoading,
        error,
    } = useOrderView(parsedOrderId);

    if (isLoading) {
        return (
            <div className="p-6 text-sm text-gray-500">
                Loading invoice...
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-6 text-sm text-red-600">
                Unable to load invoice.
            </div>
        );
    }

    if (!data) {
        return (
            <div className="p-6 text-sm text-gray-500">
                Invoice not found.
            </div>
        );
    }

    return (
        <div className="p-6">
            <OrderPaymentView data={data} />
        </div>
    );
}